import { Button } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import { userAtom } from '../auth/userAtoms';
import { feedbackDialogOpenAtom } from './atoms';
import { FeedbackDialog } from './FeedbackDialog';

/**
 * Header entry point for the feedback form. Matches the neighboring "TEMPO
 * Alerts" pill and renders only for an authenticated user.
 */
export const FeedbackButton = () => {
  const user = useAtomValue(userAtom);
  const setOpen = useSetAtom(feedbackDialogOpenAtom);

  if (!user) return null;

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        disableElevation
        disableRipple={false}
        sx={{
          color: 'white',
          backgroundColor: 'rgb(0, 120, 174)',
          padding: '0.5rem 1rem',
          marginRight: '1rem',
          borderRadius: '2px',
          textTransform: 'none',
          fontSize: 'inherit',
          minWidth: 0,
          lineHeight: 'normal',
          '&:hover': { backgroundColor: 'rgb(0, 108, 157)' },
        }}
      >
        Feedback
      </Button>
      <FeedbackDialog />
    </>
  );
};
